import { computed } from 'vue';

/**
 * True when the app is served from the US site (a bare `.com` host) or from
 * localhost (dev convenience, matching useProductHub). Used to gate US-only
 * marketing copy that is not appropriate on regional TLDs (.ca, .ie,
 * .com.hk, .com.sg, .com.au, etc.).
 *
 * `.com.hk`/`.com.sg`/`.com.au` end with `.hk`/`.sg`/`.au`, so `endsWith('.com')`
 * correctly returns false for them.
 */
export function useUsDomain() {
  const isUsDomain = computed(() => {
    if (typeof window === 'undefined') return false;
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return true;
    return hostname.endsWith('.com');
  });

  return { isUsDomain };
}
